// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as TourComponent} from './Tour.svg';

import Icon, { TIconProps } from '../Icon';

export const IconTour = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <TourComponent/>
  </Icon>
));
